var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zM9.605 16.565h4.533v13.618H9.605V16.566zm4.826-4.213c-.03-1.335-.984-2.352-2.535-2.352-1.55 0-2.564 1.017-2.564 2.352 0 1.308.984 2.354 2.505 2.354h.03c1.58 0 2.564-1.046 2.564-2.354zm10.832 3.893c2.982 0 5.218 1.947 5.218 6.13v7.808H25.95v-7.286c0-1.83-.656-3.078-2.297-3.078-1.252 0-1.998.841-2.325 1.655-.12.29-.15.697-.15 1.104v7.605h-4.532s.06-12.34 0-13.618h4.532v1.93c.602-.928 1.68-2.25 4.086-2.25z",
    fill: "currentColor"
  })));
}

export default SvgLinkedIn;